//----- Component --------------------------------------------------------/

// Developer :  Nicolas Pascucci

// Creation Date : 11/02/2025

// Version : 1

// Description : eliminación de ficha de RRHH 

//

//------Changes --------------------------------------------------------------------- -------------//

// Change Date :

// Change by :

// Change description:

//

// Change Date :

// Change by :

// Change description:

//
//========================================================================/
import React, { useState, useEffect, useMemo } from "react";
import {
  Alert,
  Button,
  Container,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  Snackbar,
  Stack,
  TextField,
  Box,
  Typography,
  DialogContentText,
  DialogActions,
  Autocomplete,
} from "@mui/material";
import moment from "moment";
//enviar mails
import { grey } from "@mui/material/colors";
import { v4 as uuidv4 } from "uuid"; //ADJUNTAR IMAGEN
import Notify from "../../Notify";
import { getData } from "../../../services/library";
import { UrlApi } from "../../../services/apirest";

function EliminarFicha(props) {
  const [eliminar, setEliminar] = useState(props.eliminar);
  const [notificacion, setNotificacion] = useState({
    open: false,
    mensaje: "",
    severity: "",
    color: "",
  });
  const style = { backgroundColor: "#ffffff", width: "100%" };
  const [renglones, setRenglones] = useState([]);
  const [almacenes, setAlmacenes] = useState([]);
  const [almacenesDestino, setAlmacenesDestino] = useState({}); // Almacenes de destino seleccionados por renglón
  const [inventariosGeneralesDestino, setInventariosGeneralesDestino] = useState({}); // Inventario general de destino por renglón
  const [inventariosPorTallesDestino, setInventariosPorTallesDestino] = useState({}); // Inventario por talles de destino por renglón
  
  const todosAlmacenesSeleccionados = () => {
    return renglones.every(renglon => almacenesDestino[renglon.id]?.id_almacen);
  };
  // Obtener almacenes
  const obtenerAlmacenes = () => {
    getData("/stock_almacenes/xsucursal/" + props.location.id, setAlmacenes);
  };

  // Obtener renglones
  const obtenerRenglones = () => {
    getData(
      "/stock_ficha_renglon/renglonxficha/" + props.row.uuid_ficha,
      setRenglones
    );
  };

  // Cargar almacenes y renglones al inicio
  useEffect(() => {
    obtenerAlmacenes();
    obtenerRenglones();
  }, []);


    // Obtener inventario general
    const obtenerInventarioGeneral = (
      renglonId,
      idAlmacen,
      idArticulo,
      setInventario
    ) => {
      if (!idAlmacen || !idArticulo) return;
  
      fetch(`${UrlApi}/stock_inventarios/xalmart/${idAlmacen}/${idArticulo}`)
        .then((res) => res.json())
        .then((data) =>
          setInventario((prev) => ({
            ...prev,
            [renglonId]: data, // Guardamos el inventario en el estado con el ID del renglón
          }))
        )
        .catch((error) =>
          console.error(
            `Error al obtener el inventario general (${renglonId}):`,
            error
          )
        );
    };

      // Obtener inventario por talles
      const obtenerInventarioPorTalles = (
        renglonId,
        idAlmacen,
        idArticulo,
        setInventario
      ) => {
        if (!idAlmacen || !idArticulo) return;
    
        getData(`/stock_prendas/detalle/${idAlmacen}/${idArticulo}`, (data) => {
          setInventario((prev) => ({
            ...prev,
            [renglonId]: data, // Guardamos el inventario por talles en el estado con el ID del renglón
          }));
        });
      };

      // Actualizar datos cuando los renglones o almacenes seleccionados cambian
      useEffect(() => {
        if (renglones.length > 0) {
          renglones.forEach((renglon) => {
            const idAlmacenDestino = almacenesDestino[renglon.id]?.id_almacen; // Almacén de destino seleccionado por renglón
            const idArticulo = renglon.id_articulo;
    
            // Obtener inventario general y por talles para el almacén de destino
            if (idAlmacenDestino && idArticulo) {
              obtenerInventarioGeneral(
                renglon.id,
                idAlmacenDestino,
                idArticulo,
                setInventariosGeneralesDestino
              );
              obtenerInventarioPorTalles(
                renglon.id,
                idAlmacenDestino,
                idArticulo,
                setInventariosPorTallesDestino
              );
            }
    
            // Obtener talles para el artículo
            // obtenerTalles(idArticulo);
          });
        }
      }, [renglones, almacenesDestino]); // Se ejecuta cuando cambia la lista de renglones o los almacenes seleccionados
    

  const handleClose = () => {
    setEliminar(!eliminar);
    if (props.onClose) {
      props.onClose();
    }
  };
  // console.log("almacenes destino",almacenesDestino);
  // console.log("inventariosGeneralesDestino", inventariosGeneralesDestino);
  // console.log("inventariosPorTallesDestino",inventariosPorTallesDestino);
  // console.log(props.row);
  
  const actualizarFicha = async (
    renglon
  ) => {
    const response = await fetch(
      `${UrlApi}/stock_ficha_rrhh/${props.row.id}`,
      {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          estado: 0,
        }),
      }
    );
  
    if (!response.ok) {
      throw new Error("error actualizacion de ficha");
    }
  }

  // Actualizar inventario por talles en el DESTINO
  const actualizarInventarioTallesDestino = async (
    stockPorTallesDestino,
    idAlmacenDestino,
    idArticulo,
    cantidadEnviada,
    renglon
  ) => {
    if (stockPorTallesDestino) {
      const talleExistenteDestino = stockPorTallesDestino.find(
        (item) => item.talle === renglon.talle // Nuevo talle seleccionado
      );
  
      if (talleExistenteDestino && talleExistenteDestino.cantidad !== undefined) {
        const nuevaCantidadDestino = talleExistenteDestino.cantidad + cantidadEnviada;
        const response = await fetch(
          `${UrlApi}/stock_prendas/${talleExistenteDestino.id}`,
          {
            method: "PUT",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              almacen: idAlmacenDestino,
              articulo: idArticulo,
              talle: talleExistenteDestino.talle, // Nuevo talle seleccionado
              cantidad: nuevaCantidadDestino,
              usuario: localStorage.getItem("user"),
            }),
          }
        );
  
        if (!response.ok) {
          throw new Error("Error al actualizar el inventario por talles en el destino");
        }
      } else {
        // Si el talle no existe en el destino, crear un nuevo registro
        
        const response = await fetch(`${UrlApi}/stock_prendas`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            almacen: idAlmacenDestino,
            articulo: idArticulo,
            talle: renglon.talle, // Nuevo talle seleccionado
            cantidad: cantidadEnviada,
            usuario: localStorage.getItem("user"),
          }),
        });
  
        if (!response.ok) {
          throw new Error("Error al crear el inventario por talles en el destino");
        }
      }
    }
  };

  // Actualizar inventario general en el DESTINO
  const actualizarInventarioDestino = async (inventarioGeneralDestino, cantidadEnviada) => {
    const nuevaCantidadDestino = inventarioGeneralDestino[0].cantidad + cantidadEnviada;
    const response = await fetch(
      `${UrlApi}/stock_inventarios/${inventarioGeneralDestino[0].id_inventario}`,
      {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          cantidad: nuevaCantidadDestino,
          usuario: localStorage.getItem("user"),
        }),
      }
    );
  
    if (!response.ok) {
      throw new Error("Error al actualizar el inventario general en el destino");
    }
  };
  
  // Crear inventario general en el DESTINO (si no existe)
  const crearInventarioDestino = async (idArticulo, idAlmacenDestino, cantidadEnviada) => {
    const response = await fetch(`${UrlApi}/stock_inventarios`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        id_articulo: idArticulo,
        id_almacen: idAlmacenDestino,
        cantidad: cantidadEnviada,
        usuario: localStorage.getItem("user"),
      }),
    });
  
    if (!response.ok) {
      throw new Error("Error al crear el inventario general en el destino");
    }
  };

  // Registrar transacción de INGRESO en el destino
  const registrarTransaccionIngreso = async (idArticulo, idAlmacenDestino, cantidadEnviada) => {
    const response = await fetch(UrlApi + "/stock_transacciones", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        id_accion: 158, // Acción de ingreso de stock
        id_articulo: idArticulo,
        almacen_destino: idAlmacenDestino,
        cantidad_recibida: cantidadEnviada,
        fecha_transaccion: moment(new Date()).format("YYYY-MM-DD HH:mm"),
        detalle_transaccion: "Ingreso de equipo por eliminación de ficha",
        usuario: localStorage.getItem("user"),
      }),
    });
  
    if (!response.ok) {
      throw new Error("Error al registrar la transacción de ingreso");
    }
  };

  const handleGuardar = async () => {
    try {
      // Iterar sobre cada renglón para procesar la baja y suba de stock
      for (const renglon of renglones) {
        
        const idArticulo = renglon.id_articulo;
        const idAlmacenDestino = almacenesDestino[renglon.id]?.id_almacen;
        const cantidadEnviada = renglon.cantidad;
        const tieneTalles = renglon.tiene_talles === 1;
    
        // 1. Registrar transacción de INGRESO en el destino
        await registrarTransaccionIngreso(idArticulo, idAlmacenDestino, cantidadEnviada);
  
        // 2. Actualizar inventario general en el DESTINO (si corresponde)
        const inventarioGeneralDestino = inventariosGeneralesDestino[renglon.id];
          if (inventarioGeneralDestino && inventarioGeneralDestino.length > 0) {
            await actualizarInventarioDestino(inventarioGeneralDestino, cantidadEnviada);
          } else {
            await crearInventarioDestino(idArticulo, idAlmacenDestino, cantidadEnviada);
          }
  
        // 6. Actualizar inventario por talles en el DESTINO (si corresponde)
        if (tieneTalles) {
          const stockPorTallesDestino = inventariosPorTallesDestino[renglon.id];
          
          await actualizarInventarioTallesDestino(
            stockPorTallesDestino,
            idAlmacenDestino,
            idArticulo,
            cantidadEnviada,
            renglon
          );
        }
  
        if (tieneTalles) {
        await actualizarFicha(
          renglon,
        );
      }
      }
  
      // Notificar éxito
      setNotificacion({
        open: true,
        mensaje: "La operación se realizó correctamente",
        severity: "success",
        color: "#D4EFDF",
      });
    } catch (error) {
      console.error(error.message);
      // Notificar error
      setNotificacion({
        open: true,
        mensaje: "Error al realizar la operación",
        severity: "error",
        color: "#F1948A",
      });
    }
  };
  
  return (
    <div>
      <Dialog open={eliminar} onClose={handleClose} maxWidth="md" fullWidth>
        {notificacion.open && (
          <Notify
            mensaje={notificacion.mensaje}
            open={notificacion.open}
            color={notificacion.color}
            handleClose={() => props.onClose(false)}
            severity={notificacion.severity}
          />
        )}
        <Box mt={1} backgroundColor={"#1F618D"}>
          <DialogTitle>
            <Typography variant="h6" align="center" color="#ffffff">
              Eliminar Ficha RR.HH.
            </Typography>
          </DialogTitle>
        </Box>
          <Box
            border={0.5}
            borderColor={grey[300]}
            backgroundColor="#F4F6F6"
            p={2}
            py={2}
            mt={1}
          >
            <DialogContent>
              <DialogContentText textAlign={"center"}>
                <>
                  {" "}
                  <b>
                    ¿Desea eliminar la ficha de {props.row.nombre_empleado}{" "}
                    {props.row.apellido_empleado}?
                  </b>{" "}
                </>
              </DialogContentText>
              <Grid container spacing={2} alignItems="center" mt={2}>
                {renglones.length > 0 ? (
                  renglones.map((renglon, index) => (
                    <Grid container spacing={1} key={index} alignItems="center">
                      <Grid item xs={2.5} mb={3}>
                        <TextField
                          fullWidth
                          label="Artículo"
                          value={renglon.nombre_articulo}
                          variant="outlined"
                          size="small"
                          InputProps={{ readOnly: true }}
                          focused
                        />
                      </Grid>
                      <Grid item xs={3} mb={3}>
                        <TextField
                          fullWidth
                          label="Descripción"
                          value={renglon.descripcion_articulo}
                          variant="outlined"
                          size="small"
                          InputProps={{ readOnly: true }}
                          focused
                        />
                      </Grid>
                      <Grid item xs={1.5} mb={3}>
                        <TextField
                          fullWidth
                          label="Talle"
                          value={renglon.nombre_talle}
                          variant="outlined"
                          size="small"
                          InputProps={{ readOnly: true }}
                          focused
                        />
                      </Grid>
                      <Grid item xs={1.5} mb={3}>
                        <TextField
                          fullWidth
                          label="Cantidad"
                          value={renglon.cantidad}
                          variant="outlined"
                          size="small"
                          InputProps={{ readOnly: true }}
                          focused
                        />
                      </Grid>

                      <Grid item xs={3.5} mb={3}>
                        <Autocomplete
                          disabled={!almacenes}
                          size="small"
                          focused
                          disableClearable
                          id="almacenDestino"
                          noOptionsText={"Almacén INEXISTENTE"}
                          options={almacenes}
                          autoHighlight
                          getOptionLabel={(almacen) =>
                            `${almacen.id_almacen} - ${almacen.nombre}`
                          }
                          onChange={(event, value) => {
                            setAlmacenesDestino((prev) => ({
                              ...prev,
                              [renglon.id]: value,
                            }));
                          }}
                          renderOption={(props, option) => (
                            <Box component="li" {...props}>
                              {option.id_almacen} - {option.nombre}
                            </Box>
                          )}
                          renderInput={(params) => (
                            <TextField
                              style={style}
                              focused
                              required
                              size="small"
                              placeholder="Tipee para buscar..."
                              {...params}
                              label="Vuelve al stock de"
                            />
                          )}
                        />
                      </Grid>
                    </Grid>
                  ))
                ) : (
                  <Typography
                    variant="body1"
                    color="text.secondary"
                    align="center"
                    sx={{ width: "100%" }}
                  >
                    No hay renglones disponibles
                  </Typography>
                )}
              </Grid>
            </DialogContent>
            <DialogActions>
              <Grid
                container
                direction="row"
                justifyContent="space-between"
                alignItems="center"
              >
                <Button
                  variant="contained"
                  onClick={handleClose}
                  style={{ backgroundColor: "#d32f2f", color: "#ffffff" }}
                >
                  Volver
                </Button>
                <Button
                //   style={{ backgroundColor: "#2e7d32", color: "#ffffff" }}
                //   type="submit"
                  variant="contained"
                  color="success"
                  onClick={handleGuardar}
                  disabled={!todosAlmacenesSeleccionados()}
                >
                  Confirmar
                </Button>
              </Grid>
            </DialogActions>
          </Box>
      </Dialog>
    </div>
  );
}

export default EliminarFicha;
